module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    attrs: {
      "title": "Grid"
    }
  }, [_c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "default",
      "description": "基础栅格",
      "code": _vm.code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(" col-12 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(" col-12 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(" col-6 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-gutter-demo",
    attrs: {
      "name": "gutter",
      "description": "间隔",
      "code": _vm.gutter_code
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gutter-box"
  }, [_vm._v("col-6")])])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "offset",
      "description": "区块偏移",
      "code": _vm.offset_code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v(" col-8 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8,
      "offset": 8
    }
  }, [_vm._v(" col-8 offset-8 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6,
      "offset": 6
    }
  }, [_vm._v(" col-6 offset-6 ")])], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": 12,
      "offset": 6
    }
  }, [_vm._v(" col-12 offset-6 ")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "pull & push",
      "description": "区块排序",
      "code": _vm.sort_code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 18,
      "push": 6
    }
  }, [_vm._v(" col-18 push-6 ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6,
      "pull": 18
    }
  }, [_vm._v(" col-6 pull-18 ")])], 1)], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "grid-demo",
    attrs: {
      "name": "responsive",
      "description": "响应式",
      "code": _vm.responsive_code
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "xsm": 0,
      "sm": 4,
      "md": 6,
      "lg": 8,
      "xlg": 6
    }
  }, [_vm._v("Col")]), _vm._v(" "), _c('Col', {
    attrs: {
      "xsm": 24,
      "sm": 16,
      "md": 12,
      "lg": 8,
      "xlg": {
        span: 6,
        offset: 3
      }
    }
  }, [_vm._v("Col")]), _vm._v(" "), _c('Col', {
    attrs: {
      "xsm": 0,
      "sm": 4,
      "md": 6,
      "lg": 8,
      "xlg": {
        span: 6,
        offset: 3
      }
    }
  }, [_vm._v("Col")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4711289a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Grid.vue
// module id = 644
// module chunks = 0